import _ from 'lodash';

class AddAdministratorsController {

  constructor(modalLoaderService, formValidationService, userAccountService, customer) {
    this.name = 'addAdministrators';
    this.modalLoaderService = modalLoaderService;
    this.userAccountService = userAccountService;
    this.EMAIL_REGEX = formValidationService.EMAIL_REGEX;
    this.RESPONSE_MESSAGES = {
      success: 'Add Administrator Successful',
      duplicateEmail: 'Duplicate Email'
    };
    this.setErrorSuccessMsgDefaults();
    this.customer = customer;
    this.isRequestCompleted = false;
  }

  setErrorSuccessMsgDefaults() {
    this.isRequestCompleted = false;
    this.isEmailDuplicate = false;
    this.isRequestFailure = false;
  }

  cancel(form) {
    this.setValidity(form);
    this.modalLoaderService.close();
  }

  setValidity(form) {
    let fields = this.getFormFields(form);
    _.each(fields, function(field) {
      if (field.$pristine) {
        field.$setValidity('required');
      }
    });
  }

  addAdministrators(form) {
    let admin = {};
    let userType = {
      customer: 1,
      mhe: 2
    };

    if (form.$valid) {
      admin.email = this.form.email;
      admin.firstName = this.form.firstName;
      admin.lastName = this.form.lastName;
      admin.userType = userType.customer;
      admin.customerId = this.customer.id;

      this.userAccountService.addAdministrators(admin)
        .then(this.onAddAdministratorSuccess.bind(this), this.onAddAdministratorFailure.bind(this));

    } else {
      this.touchFormFields(form);
    }
  }

  onAddAdministratorSuccess(response) {
    if (response.data.message === this.RESPONSE_MESSAGES.success) {
      this.isRequestCompleted = true;
      this.firstName = this.form.firstName;
      this.lastName = this.form.lastName;
      this.resetFormDefaults();
    }
  }

  onAddAdministratorFailure(response) {
    if (response.data.message === this.RESPONSE_MESSAGES.duplicateEmail) {
      this.isEmailDuplicate = true;
    } else {
      this.isRequestFailure = true;
    }
  }

  touchFormFields(form) {
    let fields = this.getFormFields(form);
    _.each(fields, function(field) {
      if (field.$pristine) {
        field.$setTouched(true);
      }
    });
  }

  getFormFields(form) {
    let fields = [];
    _.each(form, function(value, key) {
      let firstLetter = key.slice(0, 1);
      if (firstLetter !== '$') {
        fields.push(value);
      }
    });
    return fields;
  }

  isRequiredInputFieldTouchedAndEmpty(form, field) {
    return form[field].$touched && form[field].$error.required;
  }

  isFormFieldErroneous(form, field) {
    return form[field].$error;
  }

  isAddAdminButtonDisabled(form) {
    if (form) {
      return this.hasFormValidationErrors(form);
    }
  }

  isFieldExceedingMaxlength(form, field) {
    return form[field].$error.maxlength;
  }

  isEmailFormatInvalid(userForm, emailHasFocus) {
    if (!emailHasFocus) {
      return userForm.email.$error.pattern;
    }
  }

  hasFormValidationErrors(form) {
    if (form.$invalid) {
      return true;
    }
  }

  capitalize(value) {
    if (value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }

  resetFormDefaults() {
    this.form.email = '';
    this.form.firstName = '';
    this.form.lastName = '';
  }

  getFullAdminName(firstName, lastName) {
    return this.capitalize(firstName) + ' ' + this.capitalize(lastName);
  }
}

AddAdministratorsController.$inject = ['modalLoaderService', 'formValidationService', 'userAccountService', 'customer'];

export
default AddAdministratorsController;


// WEBPACK FOOTER //
// ./app/components/addAdministrators/addAdministrators.controller.js